import { connect } from 'react-redux';
import SelectionWhatifView from '../../../SelectionWhatif/SelectionWhatifView';
import { goalId as selectedGoalId } from '../../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import RouteDictionary from '../../../WhatIfsRouteDictionary';

import {
  yearOptions,
  yearSelected,
} from './PurchaseYearSelector';

import {
  updateWhatIfsData,
  applyWhatIf,
  fetchWhatIfOptions,
  initialPlanImpact,
  planImpact,
} from '../../../WhatIfsActions';

import {
  loading,
  nullableFpIdSelector,
  areOptionsLoaded,
  whatIfInnerSelector,
  whatIfTemplateInnerSelector,
  impactSelector,
  nullableTitleSelector,
  nullableGroupTitleSelector,
} from '../../../WhatIfsSelector';

const mapStateToProps = (state, ownProps) => ({
  fpId: nullableFpIdSelector(state, ownProps),
  goalId: selectedGoalId(state, ownProps),
  areOptionsLoaded: areOptionsLoaded(state, ownProps),
  whatIf: whatIfInnerSelector(state, ownProps),
  whatIfTemplate: whatIfTemplateInnerSelector(state, ownProps),
  options: yearOptions(state, ownProps),
  loading: loading(state, ownProps),
  title: nullableTitleSelector(state, ownProps),
  groupTitle: nullableGroupTitleSelector(state, ownProps),
  planImpactItems: impactSelector(state, ownProps),
  value: yearSelected(state, ownProps),
  id: 'GoalYear',
  label: 'Desired Purchase Year',
  valueStorePath: 'WhatIf.Year',
});

const mapDispatchToProps = dispatch => ({
  storeData: (goalId, whatifType) => (data, clientId) => {
    dispatch(updateWhatIfsData(clientId, goalId, whatifType, {
      ...data,
      WhatIf: {
        ...data.WhatIf,
        Year: data.WhatIf.Year === 'PurchaseAtRetirement' ? null : data.WhatIf.Year,
        PurchaseAtRetirement: data.WhatIf.Year === 'PurchaseAtRetirement',
      },
    }));
  },
  fetchPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(planImpact(
      clientId,
      fpId,
      goalId,
      whatIf,
      RouteDictionary[whatIfTemplate.WhatIfType],
      Object.keys(whatIfTemplate),
      whatIfTemplate.WhatIfType,
    ));
  },
  fetchInitialPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(initialPlanImpact(
      clientId,
      fpId,
      goalId,
      whatIf,
      RouteDictionary[whatIfTemplate.WhatIfType],
      Object.keys(whatIfTemplate),
      whatIfTemplate.WhatIfType,
    ));
  },
  fetchData: (clientId, fpId, goalId, whatifType) => {
    dispatch(fetchWhatIfOptions(
      clientId,
      fpId,
      goalId,
      RouteDictionary[whatifType],
      whatifType,
    ));
  },
  applyWhatIf: (clientId, fpId, goalId, whatIf, whatIfTemplate) => () => {
    dispatch(applyWhatIf(
      clientId,
      fpId,
      goalId,
      whatIf,
      RouteDictionary[whatIfTemplate.WhatIfType],
      Object.keys(whatIfTemplate),
      whatIfTemplate.WhatIfType,
    ));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectionWhatifView);
